<script setup>
import PartnerTable from "@frontJs/components/tables/projectManagement/apikom/PartnerTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import TabGroup from "@js/components/tabs/TabGroup.vue";
import TabPanel from "@js/components/tabs/TabPanel.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const selectedTab = ref(0);

function changeTab(index) {
  selectedTab.value = index;
}

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title>
      {{ t("title.partners") }} - {{ t("title.apikom") }} -
      {{ t("title.projectManagement") }} - {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle>
    {{ t("title.projectManagement") }} - {{ t("title.apikom") }} -
    {{ t("title.partners") }}
  </PageTitle>

  <TabGroup
    :selected-tab="selectedTab"
    :change-tab="changeTab"
    :tabs="{
      all: t('title.all'),
      archived: t('title.archived'),
    }"
  >
    <template #panels>
      <TabPanel without-background unmount>
        <PartnerTable user-session-key="partners" />
      </TabPanel>

      <TabPanel without-background unmount>
        <PartnerTable user-session-key="partners_archived" archived />
      </TabPanel>
    </template>
  </TabGroup>
</template>
